export default __webpack_public_path__ + "static/beauty-look-spring-922c55a3dd6f71921dd0aa68f07bb16a.jpg";